module.exports = __webpack_public_path__ + "img/key_features--comfort.c1265507.jpg";